export default __webpack_public_path__ + "static/media/dashboard.412bb2df.svg";